import { useParams } from "react-router-dom";
import { SingleChallenge } from "../components/single/SingleChallenge.fetcher";

export default function SingleChallengePage() {
  const { zoneId, slug } = useParams();

  if (!slug) {
    return <></>;
  }

  if (zoneId) {
    return <SingleChallenge slug={slug} zone={zoneId} />;
  }

  return <SingleChallenge slug={slug} />;
}
